import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useGQL = () => {
	const authenticatedFetch = useAuthenticatedFetch()

	return async (
		query,
		variables = null,
		aiOrders = [],
		apiVersion = null,
	) => {
		return await authenticatedFetch("/api/graphql", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				query,
				variables,
				aiOrders,
				apiVersion,
			}),
		})
			.then((res) => {
				if (!res) {
					return { data: null, errors: [{ message: "No response" }] }
				}

				if (res.status === 413) {
					return {
						data: null,
						errors: [{ message: "Request entity too large" }],
					}
				} else {
					return res.json()
				}
			})
			.then((json) => {
				if (json?.errors) {
					console.error("useGQL json.errors", json.errors)
					return { data: null, errors: json.errors }
				} else if (json?.data) {
					const operationName = Object.keys(json.data)?.[0] || ""
					if (
						operationName &&
						json.data[operationName]?.userErrors?.length
					) {
						return {
							data: null,
							errors: json.data[operationName].userErrors,
						}
					} else {
						return { data: json.data, errors: null }
					}
				} else {
					return {
						data: null,
						errors: [{ message: "Unspecified error 2" }],
					}
				}
			})
			.catch((err) => {
				console.error("useGQL catched error", err)
				return { data: null, errors: [{ message: err.message }] }
			})
	}
}
